/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Order_Payment_4Inputs */

const vi_carrier_order_payment_4 = /** @type {(inputs: Carrier_Order_Payment_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người nhận trả cước`)
};

/**

* @param {Carrier_Order_Payment_4Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_order_payment_4 = /** @type {((inputs?: Carrier_Order_Payment_4Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Order_Payment_4Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_order_payment_4(inputs)
});